import P5 from "p5";
import { CoinFlipper } from "./coin-flipper";

const flipper = new CoinFlipper();

const sketch = (p5: P5) => {
  let t = 0;
  let sum = 0;

  const backgroundColor = p5.color("#fdfdfd");
  const chartColor = p5.color("#000000");
  const zeroLine = p5.color("#000000");

  const writeCaption = () => {
    p5.push();
    p5.textStyle("italic");
    p5.text("Figure 1: Sequence of Coin Flips ", 0, p5.height - 20);
    p5.pop();
  };

  const writeZero = () => {
    p5.text(" 0", p5.width - 50, p5.height / 2 - 5, 20);
  };

  const drawZeroLine = () => {
    p5.fill(zeroLine);
    p5.rect(0, p5.height / 2, p5.width - 55, 1);
  };

  const writeResult = (result: number) => {
    p5.text(result, p5.width - 50, p5.height / 2 - sum + 5);
  };

  const dimCanvas = () => {
    p5.push();
    const filler = p5.color(backgroundColor);
    filler.setAlpha(100);
    p5.fill(filler);
    p5.rect(0, 0, p5.width, p5.height - 50);
    p5.pop();
  };

  const plotPoint = (x, y) => {
    p5.push();
    p5.stroke(chartColor);
    p5.strokeWeight(1.3);
    p5.point(x, y);
    p5.pop();
  };

  p5.setup = () => {
    const canvas = p5.createCanvas(740, 230);
    canvas.parent("fig1");

    p5.noStroke();
    p5.background(backgroundColor);

    writeZero();
    drawZeroLine();
    writeCaption();

    p5.frameRate(120);
  };

  p5.draw = () => {
    const coinFlip = flipper.flip();
    sum = sum + coinFlip;
    t++;

    plotPoint(t, p5.height / 2 - sum);

    if (t > p5.width - 55) {
      dimCanvas();
      drawZeroLine();
      writeZero();
      writeResult(sum);

      t = 0;
      sum = 0;
    }
  };
};

new P5(sketch);
